





















import { listFactory } from '@/main/pages/listFactory';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';

import { store } from './store/list';
import { apiProvider } from './api';
import { NAME } from './constants';

export default listFactory(NAME, store).extend({
	data() {
		return {
			fileList: [],
		};
	},
	methods: {
		async submitEdlUpload(file: any) {
			try {
				this.startLoading();
				const formData = new FormData();
				formData.append('edlFile', file.raw as any);
				const res = await apiProvider.createFromFile(formData);
				if (res && res.data) {
					await openEdit(NAME, PageMode.EDIT, { id: res.data });
				}
			} finally {
				this.fileList = [];
				this.endLoading();
			}
		},
	},
});
